import ErrorEntities from '@/models/error-entities'

import { AuthMutationTypes } from '@/store/modules/auth/AuthMutationTypes'

export interface State {
  errors: ErrorEntities
  pending: boolean
}

const initialState: State = {
  errors: {},
  pending: false,
}

export default {
  state: initialState,
  getters: {
    getResetPasswordPageError(state: State): ErrorEntities {
      return state.errors
    },
    getResetPasswordPagePending(state: State): boolean {
      return state.pending
    },
  },
  mutations: {
    [AuthMutationTypes.ResetPassword](state: State) {
      state.pending = true
      state.errors = {}
    },
    [AuthMutationTypes.ResetPasswordSuccess](state: State) {
      state.pending = false
      state.errors = {}
    },
    [AuthMutationTypes.ResetPasswordFailure](
      state: State,
      errors: ErrorEntities,
    ) {
      state.pending = false
      state.errors = errors
    },
  },
}
